import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Noimage from "../../images/3.png";
import './SingleProductBikes.css'

function SingleProductBikes() {
  const productId = sessionStorage.getItem("productId");

  const [product, setProduct] = useState([]);
  const [productImg, setProductImg] = useState([]);
  const [mainImage, setMainImage] = useState("");

  useEffect(() => {
    if (productId) {
      fetchProductDetails();
      fetchProductImages();
    }
  }, [productId]);

  async function fetchProductDetails() {
    try {
      const res = await fetch(`/allBikesByPID/${productId}`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Data not in array format");
      setProduct(data);
    } catch (err) {
      console.error("Product fetch error:", err.message);
    }
  }

  async function fetchProductImages() {
    try {
      const res = await fetch(`/allProductsMediaByPID/${productId}`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Media not in array format");
      setProductImg(data);
      if (data.length > 0) {
        setMainImage(`data:image/png;base64,${data[0].productImages}`);
      }
    } catch (err) {
      console.error("Image fetch error:", err.message);
    }
  }

  const handleThumbnailClick = (img) => {
    setMainImage(`data:image/png;base64,${img.productImages}`);
  };

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "10px 30px",
    width: "100%",
  };

  const renderSpec = (label, value) => {
    if (value === undefined || value === null || value === "") return null;
    return (
      <div style={{ display: "flex" }}>
        <strong style={{ width: "180px" }}>{label}:</strong>
        <span>{value}</span>
      </div>
    );
  };

  const sectionHeadingStyle = {
    marginTop: "20px",
    fontWeight: "bold",
    fontSize: "16px",
    color: "#36c2c2",
    borderBottom: "1px solid #ccc",
    paddingBottom: "5px",
  };

  return (
    <>
      <div className="product-container">
        <div className="thumbnail-column">
          {productImg.map((img, idx) => (
            <img
              key={idx}
              src={
                img.productImages
                  ? `data:image/png;base64,${img.productImages}`
                  : Noimage
              }
              alt="Thumbnail"
              onClick={() => handleThumbnailClick(img)}
              className={`thumbnail-image ${
                mainImage.includes(img.productImages) ? "active-thumbnail" : ""
              }`}
            />
          ))}
        </div>

        <div className="main-image-container">
          <img
            src={mainImage || Noimage}
            alt="Main Product"
            className="main-image"
          />
        </div>

        <div className="product-details">
          {product.map((prdct) => (
            <div key={prdct.productID}>
              <h2 className="product-title">{prdct.productName}</h2>
              <p>
                <strong className="text-gray">Price:</strong>{" "}
                <span className="text-red">₹{prdct.price}</span>
              </p>
              <p>
                <strong>Color:</strong> {prdct.color}
              </p>
              <p>
                <strong>Age Group:</strong> {prdct.ageGroup}
              </p>
              <p>
                <strong>Brand:</strong> {prdct.brand}
              </p>

              <a
                href={`https://wa.me/919490384177?text=Hi, I'm interested in buying the product: ${encodeURIComponent(
                  prdct.productName
                )}, Price: ₹${prdct.price}`}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-button"
              >
                Shop on WhatsApp
              </a>
            </div>
          ))}
        </div>
      </div>

      {/* Description Section */}
      {product.map((prdct) => (
        <div className="spec-container" key={`desc-spec-${prdct.productID}`}>
          <h4 className="section-title">Description</h4>
          <p>{prdct.description}</p>

          <h4 className="section-title">Specifications</h4>

          <h5 className="section-subtitle">General</h5>
          <div className="spec-grid">
            {renderSpec("Type", prdct.type)}
            {renderSpec("Model Number", prdct.modelNumber)}
            {renderSpec("Color", prdct.color)}
            {renderSpec("Speed", prdct.speed)}
            {renderSpec("Weight", prdct.weight)}
            {renderSpec("Country of Origin", prdct.countryOfOrigin)}
            {renderSpec("Manufacturer", prdct.manufacturer)}
          </div>

          <h5 className="section-subtitle">Power Features</h5>
          <div className="spec-grid">
            {renderSpec("Battery Type", prdct.batteryType)}
            {renderSpec(
              "Battery Included",
              prdct.batteryIncluded ? "Yes" : "No"
            )}
            {renderSpec("Rechargeable", prdct.rechargeable ? "Yes" : "No")}
          </div>

          <h5 className="section-subtitle">Convenience Features</h5>
          <div className="spec-grid">
            {renderSpec("Parental Remote", prdct.parentalRemote ? "Yes" : "No")}
            {renderSpec(
              "MP3 Player Supported",
              prdct.mpThreePlayerSupported ? "Yes" : "No"
            )}
            {renderSpec(
              "Other Convenience Features",
              prdct.otherConvenienceFeatures
            )}
          </div>

          <h5 className="section-subtitle">Dimensions</h5>
          <div className="spec-grid">
            {renderSpec("Dimensions", prdct.dimentions)}
            {renderSpec("Maximum User Weight", prdct.maximumUserWeight)}
          </div>

          <h5 className="section-subtitle">Warranty</h5>
          <div className="spec-grid">
            {renderSpec("Warranty", prdct.warrenty)}
            {renderSpec("Covered in Warranty", prdct.coveredInWarranty)}
            {renderSpec("Not Covered in Warranty", prdct.notCoveredInWarranty)}
          </div>
        </div>
      ))}
    </>
  );
}


export default SingleProductBikes;